import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Button } from './ui/Button';
import { CheckIcon } from 'lucide-react';
export function ProductRevealSection() {
  const chapters = [{
    num: '01',
    title: 'Ciclos de sueño del bebé',
    desc: 'Por qué el despertar a los 40-60 minutos es tan común y qué significa realmente para el desarrollo de tu bebé.'
  }, {
    num: '02',
    title: 'Causas reales de los despertares nocturnos',
    desc: 'Aprende a identificar si es hambre real, asociación de sueño, sobrecansancio, ambiente o regresión.'
  }, {
    num: '03',
    title: 'Ventanas de sueño + tablas por edad',
    desc: 'Tablas claras, señales de sueño y cómo armar un horario flexible sin estrés desde recién nacido hasta 3 años.'
  }, {
    num: '04',
    title: 'Rutinas efectivas por etapa',
    desc: 'Rutinas cortas y realistas con ejemplos concretos desde recién nacidos hasta los 3 años.'
  }, {
    num: '05',
    title: 'Regresiones del sueño (4, 8 y 12 meses)',
    desc: 'Qué son, cuándo aparecen y qué hacer para no perder lo avanzado. Sin pánico.'
  }, {
    num: '06',
    title: 'Estrategias para reducir despertares',
    desc: 'Qué hacer en la madrugada, cómo responder sin empeorar el patrón y cómo avanzar de forma gradual.'
  }, {
    num: '07',
    title: 'Ambiente ideal para dormir',
    desc: 'Lo esencial: oscuridad, temperatura, ruido blanco bien usado y seguridad del sueño.'
  }, {
    num: '08',
    title: 'Errores comunes que sabotean el sueño',
    desc: 'Y cómo corregirlos sin culpa. Aunque los hayas cometido con la mejor intención.'
  }];
  const includes = ['47 páginas de ciencia del sueño aplicada', 'Tablas de ventanas de sueño por edad', 'Rutinas paso a paso por etapa', 'Guía completa de regresiones', 'Checklist de higiene del sueño', 'Escrito para madres cansadas: directo y escaneable'];
  return <section className="py-16 md:py-24 px-4 md:px-6 bg-navy" data-id="element-245">
      <div className="max-w-6xl mx-auto" data-id="element-246">
        <FadeIn data-id="element-247">
          <div className="mb-16" data-id="element-248">
            <div className="inline-block bg-navy-light border border-white/10 text-white/80 font-medium text-xs md:text-sm px-4 py-1.5 rounded-full mb-6 uppercase tracking-wider" data-id="element-249">
              Lo que vas a encontrar dentro
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-black text-white leading-tight mb-5" data-id="element-250">
              Una guía completa,
              <br data-id="element-251" />
              no{' '}
              <span className="text-gold italic font-normal" data-id="element-252">tips sueltos</span>
            </h2>
            <p className="text-lg text-white/70 max-w-2xl leading-relaxed" data-id="element-253">
              47 páginas escritas para madres cansadas: claro, directo, fácil de
              aplicar. Empieza por el capítulo que más necesitas hoy.
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_400px] gap-10 lg:gap-16 items-start" data-id="element-254">
          {/* Chapters List */}
          <div className="flex flex-col gap-4" data-id="element-255">
            {chapters.map((chapter, index) => <FadeIn key={index} delay={index * 0.05} direction="up" data-id="element-256">
                <div className="flex gap-5 p-6 bg-navy-light rounded-2xl border border-white/5 transition-all duration-300 hover:translate-x-2 hover:shadow-lg hover:border-gold/30" data-id="element-257">
                  <div className="w-10 h-10 bg-gradient-to-br from-navy to-navy-mid rounded-xl flex items-center justify-center text-sm font-bold text-white flex-shrink-0" data-id="element-258">
                    {chapter.num}
                  </div>
                  <div data-id="element-259">
                    <h3 className="font-bold text-white text-base md:text-lg mb-1" data-id="element-260">
                      {chapter.title}
                    </h3>
                    <p className="text-sm text-white/70 leading-relaxed" data-id="element-261">
                      {chapter.desc}
                    </p>
                  </div>
                </div>
              </FadeIn>)}
          </div>

          {/* Sticky Product Card */}
          <div className="lg:sticky lg:top-24" data-id="element-262">
            <FadeIn delay={0.4} direction="left" data-id="element-263">
              <aside className="bg-gradient-to-br from-navy to-navy-mid rounded-3xl p-8 md:p-10 border border-gold/20 shadow-2xl shadow-navy-card/50 text-white" data-id="element-264">
                <div className="w-16 h-16 bg-gold/15 border-2 border-gold/30 rounded-full flex items-center justify-center text-3xl mb-6" data-id="element-265">
                  🌙
                </div>
                <h3 className="font-serif text-2xl font-bold mb-2" data-id="element-266">
                  Guía del Sueño del Bebé
                </h3>
                <p className="text-sm text-gold mb-6" data-id="element-267">
                  0 a 3 años · Maternidad en Equilibrio
                </p>

                <div className="h-px bg-white/10 mb-6" data-id="element-268" />

                <ul className="flex flex-col gap-3 mb-8" data-id="element-269">
                  {includes.map((item, i) => <li key={i} className="flex items-start gap-3 text-sm text-white/85" data-id="element-270">
                      <span className="text-gold font-bold mt-0.5" data-id="element-271">✓</span>
                      <span data-id="element-272">{item}</span>
                    </li>)}
                </ul>

                <div className="h-px bg-white/10 mb-6" data-id="element-273" />

                <Button href="#pricing" className="w-full text-center py-4" data-id="element-274">
                  Ver Precio y Descargar →
                </Button>
              </aside>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}